import React from 'react';
import styled from 'styled-components';
import { leftArrow2, rightArrow2 } from '../../assets/icons';

type Props = {
  onClick: () => void;
  increase: boolean;
};

const ConversationAdjust = ({ increase, onClick }: Props) => {
  return (
    <Conversation onClick={() => onClick()}>
      <Wrapper>
        {increase ? <ArrowIcon src={rightArrow2} /> : <ArrowIcon src={leftArrow2} />}
      </Wrapper>
    </Conversation>
  );
};

export default ConversationAdjust;

const ArrowIcon = styled.img`
  width: 24pt;
  height: 24pt;
  padding: 5pt;
  margin-top: 5pt;
`;

const Conversation = styled.li`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 15px;
  display: grid;
  cursor: pointer;
`;

const Wrapper = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.beige};
  border-radius: 50%;
  width: 34pt;
  height: 34pt;
  text-align: center;
  margin: auto;
`;
